<template>
<div></div>
</template>

<script>
import QuestionnairePreviewModal from "@/components/QuestionnairePreviewModal";
import { mapGetters } from "vuex"

export default {
  name: "AgentRITMStatusContainer",
  computed: {
    ...mapGetters(["ritmStatusAccessPoint"])
  },
  beforeDestroy() {
    document.documentElement.style.overflow = "auto";
  },
  data() {
    return {
      isUserRoutedToStatusModal: false
    }
  },
  mounted() {
    this.initializeModal()
  },
  methods: {
    initializeModal() {
      let params = this.$route.params
      if(params && params.ritm) {
        document.documentElement.style.overflow = "hidden";
        let exitPoint = params.exitPoint
        this.$modal.show(
              QuestionnairePreviewModal,
            {caseNumber: params.ritm, exitPoint: exitPoint},
            {
              name: "QuestionnairePreviewModal",
              adaptive: true,
              height: "auto",
              width: "730",
            }, {
              closed: () => {
                if(!this.isUserRoutedToStatusModal) {
                  /* eslint-disable no-console */
                  if(this.ritmStatusAccessPoint) {
                    this.$router.push({ path: this.ritmStatusAccessPoint }).catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }});
                  } else {
                    this.$router.push({ name: "StatusDashboard" }).catch((ex) => { if(ex.name !== 'NavigationDuplicated') { console.error(ex) }});
                  }
                }
              },
              onRouteToStatusModal: (caseNumber) => {
                this.isUserRoutedToStatusModal = true
                this.$modal.hide("QuestionnairePreviewModal")
                this.$router.push({name: "RITMStatus", params: { ritm: caseNumber }})
              }
            }
        )
      } else {
        this.$router.push({name: "StatusDashboard"})
      }
    }
  }
}
</script>

<style scoped>

</style>